<template>
  <div>
    <v-layout align-center style="height:100vh">
      <v-flex xs4 lg4 xl4 hidden-md-and-down class="session-left">
        <v-spacer>&nbsp;</v-spacer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg8 xl8 class="text-xs-center">
        <v-container>
          <v-layout row wrap>
            <v-flex lg4>
              <v-spacer>&nbsp;</v-spacer>
            </v-flex>
            <v-flex lg4>
              <div class="text-xs-center text-lg-center">
                <img :src="appLogo" class="img-responsive mb-3" width="200" height="78">
                <br>
                <span style="font-size:21px;font-weight:410">Olvidé mi contraseña</span>
                <p
                  class="mt-4"
                  style="font-size:12px"
                >Ingrese su email para reestablecer su contraseña.</p>
                <v-form v-model="valid" class="mb-4">
                  <v-text-field
                    label="E-mail"
                    placeholder="Escriba su email"
                    v-model="email"
                    required
                    :rules="[rules.required,rules.email]"
                  ></v-text-field>
                  <div>
                    <v-btn
                      :disabled="loadingButton||!valid"
                      :loading="loadingButton"
                      color="primary"
                      large
                      @click=" forgotPassword()"
                    >RESTAURAR CONTRASEÑA</v-btn>
                  </div>
                </v-form>
                <div>
                  <router-link style="font-size:12px" to="/session/login">Regresar al inicio</router-link>
                </div>
              </div>
            </v-flex>
            <v-flex lg4>
              <v-spacer>&nbsp;</v-spacer>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SessionServices from '@/services/SessionServices';
export default {
  computed: {
    ...mapGetters([      
    ])
  },
  data() {
    return {
      userProfileSiaerp:{},
      loadingButton: false,
      appLogo: "/static/img/logo2.png",
      credentials: {
        client_id: "5c3785ae6762b664f4760c52",
        client_secret:
          "2701cba313c1494cbcfdf2a2f34d9174d64f95457b8dd0fe79932c3b07cba28d",
        scope: "register_user",
        grant_type: "client_credentials"
      },

      email: "",

      valid: false,
      rules: {
        required: value => !!value || "Campo Requerido",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Dirección email invalida";
        }
      }
    };
  },
  mounted() {
    //this.connect();
  },
  methods: {
    async forgotPassword() {
      this.loadingButton = true;
      var recoverPass = {
        emailUser: this.email,
        tokenPassword: localStorage.getItem("tokenPassword")
      };

      var validaEmail = await this.validaUsuarioActivo();
      await  this.$store.dispatch("checkEmail", this.email).then(res => {
        if(!validaEmail)
        {
          switch (res.data.code) {
          case 401:
            /* if (res.data.msg == "User not registered into application") { */
            this.$root.$emit(
              "showSnackBar",
              "Correo electrónico no registrado",
              "error"
            );
            this.loadingButton = false;
            /*    } */
            break;
          case 404:
            /*    if (res.data.msg == "User email is not registered") { */
            this.$root.$emit(
              "showSnackBar",
              "Correo electrónico no registrado",
              "error"
            );
            this.loadingButton = false;
            /*    } */
            break;
          case 406:
            /*  if (res.data.msg == "User email is not registered, but its not valid email address") { */
            this.$root.$emit(
              "showSnackBar",
              "Correo electrónico no valido",
              "error"
            );
            this.loadingButton = false;
            /*   } */
            break;
          case 200:
            this.$store.dispatch("forgotPassword", recoverPass).then(res => {
              this.$router.push("/session/reset-password");
              localStorage.setItem("emailTemp", this.email);
              localStorage.setItem("identification", this.userProfileSiaerp.Identificacion);
              this.loadingButton = false;
              this.$root.$emit(
                "showSnackBar",
                "Se ha enviado un código a su correo electrónico",
                "accent"
              );
            });
            break;
          default:
            this.$root.$emit(
              "showSnackBar",
              "Ocurrio un error al verificar correo electrónico",
              "error"
            );
            this.loadingButton = false;
            break;
        }
          
        }else{
          this.$root.$emit(
              "showSnackBar",
              "Usuario inactivo, por favor comuníquese con su ejecutivo comercial",
              "error"
            );
            this.loadingButton = false;

        }
        
      });
    },
   validaUsuarioActivo(){
      var respu = false;

     
      SessionServices.getInfoUserByEmail(this.email).then((dataUserSiaerp=>{
        this.userProfileSiaerp = dataUserSiaerp.data
        }))
      if(this.userProfileSiaerp.Estado == "I") 
      {
        respu = true
      } 
      return respu;
    },
  }
};
</script>